export function isInputOnlyDigit(input: string) {
	return /^\d+$/.test(input);
}

export function isInputAnEmail(input: string) {
	return input.toLowerCase().includes('@');
}
